import { AfterContentChecked, ChangeDetectorRef, Component, OnChanges, OnDestroy, OnInit, SimpleChanges, Output, EventEmitter, Input } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';

import { SmWownetModel } from '@app/models/system/sm-wownet.model';
import { PdtDetailModel } from '@app/models/shoppingmall/pdt-detail.model';
import { getSmWownet, SmWownetState } from '@app/selectors/system/sm-wownet.selector';
import { OverlayLoadingState } from '@app/selectors/overlay-loading.selector';
import { getGradeOfProducts, getPdtImages, getPdtNotify, getProductReviewImages, getResultSaveCommentPdt, getReviewByPdtCd, getTotalPdtReview, getTotalProductReviewImages, PdtDetailState , getListComment} from '@app/selectors/shoppingmall/pdt-detail.selector';
import { ConvertUtil } from '@app/common/util/convert.util';
import { setShowOverlayLoading } from '@app/actions/overlay-loading.action';
import { ImageKindConstant } from '@app/common/constant/image-kind.constant';
import { ValidationUtil } from '@app/common/util/validation.util';
import { getCountPdtReview, getGradeOfProduct, getPdtReview, actionGetProductReviewImages, actionGetTotalProductReviewImages, saveCommentPdt, loadCommentPdt, clearProductDetailState } from '@app/actions/shoppingmall/pdt-detail.action';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { PaginationInstance } from 'ngx-pagination';
import { ResultProc } from '@app/models/system/result-proc.model';
import { environment } from '@enviroments/environment';
import { AuthUtil } from '@app/common/util/auth.util';
import { WAlertState } from '@app/selectors/w-alert.selector';
import { clearWAlert, setWAlert } from '@app/actions/w-alert.action';
import { WAlertConstant } from '@app/common/constant/w-alert-icon.constant';
import { TranslateService } from '@ngx-translate/core';
import { CartState } from '@app/selectors/shoppingmall/cart.selector';
import { CartUtil } from '@app/common/util/cart.util';
import { addToCart, setIsBuyNow } from '@app/actions/shoppingmall/cart.action';
import { CustomerPrice } from '@app/pipes/customer-price.pipe';
import { Company } from '@app/models/system/company.model';
import { CompanyState, getCompany } from '@app/selectors/system/company.selector';
import { loadCompany } from '@app/actions/system/company.actions';

declare const productDetailScroll: any;

@Component({
  selector: 'product-content',
  templateUrl: './product-content.component.html',
  styleUrls: ['./product-content.component.css'],
  providers: [CustomerPrice]
})
export class ProductContentComponent implements OnInit, OnChanges, OnDestroy, AfterContentChecked {
  @Output()
  outputAvgGrade = new EventEmitter<Number>();

  smWownet$ = new Observable<SmWownetModel>();
  urlWownet: string = "";

  pdtImages$ = new Observable<PdtDetailModel[]>();
  pdtImages: PdtDetailModel[] = [];

  pdtNotify$ = new Observable<PdtDetailModel[]>();
  pdtNotify: PdtDetailModel[] = [];

  pdtReviews$ = new Observable<PdtDetailModel[]>();
  pdtReviews: PdtDetailModel[] = [];

  gradeOfProducts$ = new Observable<PdtDetailModel[]>();
  gradeOfProducts: PdtDetailModel[] = [];

  productReviewImages$ = new Observable<PdtDetailModel[]>();
  productReviewImages: PdtDetailModel[] = [];

  total$ = new Observable<Number>();
  total: number = 0;

  totalProductReviewImage$ = new Observable<Number>();
  totalProductReviewImage: number = 0;

  company$ = new Observable<Company>();
  company: Company = {} as Company;

  page: number = 1;
  len: number = 5;
  totalItems: number = 0;
  avgGrade: number = 0;
  total5Grade: number = 0;
  total4Grade: number = 0;
  total3Grade: number = 0;
  total2Grade: number = 0;
  total1Grade: number = 0;
  totalGrade: number = 0;
  percentRating : number = 0;

  pdtCdUrl: string = '';
  orderBy: string = 'new';

  showPopup: boolean = false;
  isLogin = AuthUtil.isLogined();

  resultComment:ResultProc = {} as ResultProc ;
  resultComment$ =  new Observable<ResultProc>();

  cmnt:string[] = [];
  openCmnt =  new Map<number,boolean>();

  listComment: PdtDetailModel[] = [];
  listComment$ = new Observable<PdtDetailModel[]>();

  seq:string[] = [];
  userid:string = '';

  isAction = new Map<String , String []> ; // seq , [isLike , isUnLike];

  sub$:Subscription = {} as Subscription
  action:string = '';

  actionConfirmLogined: string = "action_confirm_logined";

  config: PaginationInstance = {
    id: "product-review",
    itemsPerPage: this.len,
    currentPage: this.page,
    totalItems: this.total,
  }

  listQtyLike:number[] = [];
  listQtyUnLike:number[] = [];

  remark: string = '';
  fullImg: boolean= false;

  @Input() 
  totalAmt: number = 0;

  @Input() 
  quantity: number = 1;

  @Input() 
  wishYn: string = 'N';

  @Output() 
  changePlus = new EventEmitter<string>();

  @Output() 
  changeMinus = new EventEmitter<string>();

  @Input() 
  pdtInfo: PdtDetailModel = {} as PdtDetailModel

  isLogined = AuthUtil.isLogined();

  @Output()
  changeWish = new EventEmitter<string>();

  isRetailAmt: boolean = false;

  constructor(
    private _smWownetStore: Store<SmWownetState>,
    private _overlayLoadingStore: Store<OverlayLoadingState>,
    private _pdtDetailStore: Store<PdtDetailState>,
    private _activatedRoute: ActivatedRoute,
    private changeDetector: ChangeDetectorRef,
    private _wAlertStore: Store<WAlertState>,
    private _translate:TranslateService,
    private _cartStore: Store<CartState>,
    private _companyStore: Store<CompanyState>,
  ) {
    this.smWownet$ = this._smWownetStore.select(getSmWownet);
    this.pdtImages$ = this._pdtDetailStore.select(getPdtImages);
    this.pdtNotify$ = this._pdtDetailStore.select(getPdtNotify);
    this.pdtReviews$ = this._pdtDetailStore.select(getReviewByPdtCd);
    this.total$ = this._pdtDetailStore.select(getTotalPdtReview);
    this.gradeOfProducts$ = this._pdtDetailStore.select(getGradeOfProducts);
    this.productReviewImages$ = this._pdtDetailStore.select(getProductReviewImages);
    this.totalProductReviewImage$ = this._pdtDetailStore.select(getTotalProductReviewImages);
    this.resultComment$ = this._pdtDetailStore.select(getResultSaveCommentPdt);
    this.listComment$ = this._pdtDetailStore.select(getListComment);
    this.company$ = this._companyStore.select(getCompany);
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  ngOnDestroy(): void {
    this._wAlertStore.dispatch(clearWAlert());
    //this.sub$.unsubscribe();
    this._pdtDetailStore.dispatch(clearProductDetailState())

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.config.itemsPerPage = this.len;
    this.config.currentPage = this.page;
  }

  ngOnInit(): void {
      this.clearData();
      this._wAlertStore.dispatch(clearWAlert());
      this._activatedRoute.paramMap.subscribe((params: ParamMap) => {
      let pdtCd = ConvertUtil.convertToSring(params.get("pdtCd"));
      this.pdtCdUrl = pdtCd;
      this._pdtDetailStore.dispatch(getGradeOfProduct({pdtCd: this.pdtCdUrl}));
      this._pdtDetailStore.dispatch(actionGetProductReviewImages({pdtCd : pdtCd, page : 0, len : 8}));
      this._pdtDetailStore.dispatch(actionGetTotalProductReviewImages({pdtCd : pdtCd}));
      this.loadTotalProductReview();
      this.loadProductReview();

      this._companyStore.dispatch(loadCompany());
      this.company$.subscribe(res =>{
        if(ValidationUtil.isNotNullAndNotEmpty(res)){
          this.company = res;
        }
      })
    });

    let member   = AuthUtil.getLoginedInfo();

    if(ValidationUtil.isNotNullAndNotEmpty(member)) {
      this.userid = String(member?.userid);
    }

    this.listComment$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.listComment = res;
        for (let index = 0; index < res.length; index++) {
          if(Number(res[index].cmntSeq) == 1)
          this.isAction.set(res[index].seq ,[res[index].likeCmt , res[index].unLikeCmt] )
        }
      } else {
        this.listComment =  [];
      }
    })

    this.smWownet$.subscribe(res =>{
      this.urlWownet = ConvertUtil.convertToSring(res.urlWownet);
      this.isRetailAmt = res.lShowRetailYn === "Y";
    });

    this.pdtImages$.subscribe(res => {

      this.remark = ConvertUtil.convertToSring(res[0]?.remark).split('\n').join('</br>');
      this.pdtImages = res.filter(x => x.imageKind !== ImageKindConstant.large && ValidationUtil.isNotNullAndNotEmpty(x.fileName));

      this.pdtImages = this.pdtImages.sort(function(a, b){
        return a.imageKind.localeCompare(ConvertUtil.convertToSring(b.imageKind));
      });

      setTimeout(() => {
        productDetailScroll();      
      }, 500);

      this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: false }));
    });

    this.pdtNotify$.subscribe(res => {
      this.pdtNotify = res;
      this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: false }));
    });

    this.total$.subscribe(res => {

      if(ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.total = Number(res);
      }
      this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: false }));
    });

     this.pdtReviews$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.pdtReviews = res;
        this.seq = [];
        this.isAction = new Map();
        this.loadComment(res);
      } else {
        this.pdtReviews = [];
      }
      this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: false }));
    });

    this.sub$ =  this.resultComment$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)){
        if(String(res.retCode =='OK') && this.action == 'save') {
          this._wAlertStore.dispatch(
            setWAlert({
                wAlert: {
                    icon: WAlertConstant.successful,
                    message: ConvertUtil.convertToSring(res.retStr),
                },
            })
          );

          this.loadProductReview();
        }

      }
    })

    this.productReviewImages$.subscribe(res => {
      this.productReviewImages = res;
    });

    this.totalProductReviewImage$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.totalProductReviewImage = Number(res);
      }
    });

    this.gradeOfProducts$.subscribe(res => {
      this.clearData();
      if(ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.gradeOfProducts = res;
        for(let i = 0; i < this.gradeOfProducts.length; i++) {
          this.totalGrade = this.totalGrade + Number(this.gradeOfProducts[i].grade);
          if(this.gradeOfProducts[i].grade == '5') {
            this.total5Grade = this.total5Grade + 1;
          } else if(this.gradeOfProducts[i].grade == '4') {
            this.total4Grade = this.total4Grade + 1;
          } else if(this.gradeOfProducts[i].grade == '3') {
            this.total3Grade = this.total3Grade + 1;
          } else if(this.gradeOfProducts[i].grade == '2') {
            this.total2Grade = this.total2Grade + 1;
          } else {
            this.total1Grade = this.total1Grade + 1;
          }
        }

        if(this.totalGrade > 0) {
          this.avgGrade = Number((((1 * this.total1Grade) + (2 * this.total2Grade) + (3 * this.total3Grade) + (4 * this.total4Grade) + (5 * this.total5Grade)) / this.gradeOfProducts.length).toFixed(1));
        } else {
          this.avgGrade = 0;
        }
        this.outputAvgGrade.emit(this.avgGrade)

        this.percentOfGrades(this.total5Grade, this.gradeOfProducts, "g5Rate");
        this.percentOfGrades(this.total4Grade, this.gradeOfProducts, "g4Rate");
        this.percentOfGrades(this.total3Grade, this.gradeOfProducts, "g3Rate");
        this.percentOfGrades(this.total2Grade, this.gradeOfProducts, "g2Rate");
        this.percentOfGrades(this.total1Grade, this.gradeOfProducts, "g1Rate");

        this.percentRating = Math.ceil((this.avgGrade * 2) * 10);
        this.setWidthStar(this.percentRating);
      }
      this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: false }));
    });
  }

  scrollElement(e1: string) {
    let element: any;

    element = document.getElementById(e1) as HTMLElement;
    element.scrollIntoView();
  }

  onOrderBy(orderBy: string): void {
    this.orderBy = orderBy;
    this.loadProductReview();
  }

  onChangePage(page: number): void {
    this.page = page;
    this.config.currentPage = page;
    this.loadProductReview();
  }

  onClickShowReviewPopup() {
    if(this.isLogin) {
      this.showPopup = true;
    } else {
      this.alertNotLogined();
    }
  }

  onOutputShowPopup(result: boolean) {
    this.showPopup = result;
  }

  loadProductReview() {
    this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));
    this._pdtDetailStore.dispatch(getPdtReview({ pdtCd: this.pdtCdUrl ,orderBy: this.orderBy,  page: Number(this.page) - 1, len: this.len}));
  }

  loadTotalProductReview() {
    this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));
    this._pdtDetailStore.dispatch(getCountPdtReview({pdtCd: this.pdtCdUrl}));
  }

  percentOfGrades(total : number, totalGrade : PdtDetailModel[], rateType : string) {
    let element = <HTMLInputElement> document.getElementById(rateType);
    if(element !== null) {
      if(total > 0) {
        element.style.width = (total / totalGrade.length) * 100 + "%";
      } else {
        element.style.width = "0%";
      }
    }
  }

  setWidthStar(avg : number) {
    if(avg > 0) {
      let fillRating = <HTMLDivElement> document.getElementById("fill-rating-review");
      fillRating.style.width = avg + "%";
    }
  }

  clearData() {
    this.totalItems = 0;
    this.avgGrade = 0;
    this.total5Grade = 0;
    this.total4Grade = 0;
    this.total3Grade = 0;
    this.total2Grade = 0;
    this.total1Grade = 0;
    this.totalGrade = 0;
    this.percentRating = 0;
    this.outputAvgGrade.emit(0);
    this.setWidthStar(0);
    this.gradeOfProducts = [];

    this.percentOfGrades(0, [], "g5Rate");
    this.percentOfGrades(0, [], "g4Rate");
    this.percentOfGrades(0, [], "g3Rate");
    this.percentOfGrades(0, [], "g2Rate");
    this.percentOfGrades(0, [], "g1Rate");
  }

  callCommentPdt(item:PdtDetailModel,index:number, isLike:string , isUnLike:string){
    this.action = 'save';

    if(isLike == 'Y') {

      for (const [key, value] of this.isAction.entries()) {
        if (key === item.seq) {
          if(value[1] == 'Y'){
            this.listQtyUnLike[index] = this.listQtyUnLike[index]-1
          }
        }
      }
      this.listQtyLike[index] =this.listQtyLike[index] + 1
    }

    if(isUnLike == 'Y') {
      for (const [key, value] of this.isAction.entries()) {
        if (key === item.seq) {
          if(value[0] == 'Y'){
            this.listQtyLike[index] =  this.listQtyLike[index]-1
          }
        }
      }
      this.listQtyUnLike[index] = this.listQtyUnLike[index] +  1
    }

    if(isLike == 'N'){
      this.listQtyLike[index] =  this.listQtyLike[index]-1
    }

    if(isUnLike == 'N'){
      this.listQtyUnLike[index] = this.listQtyUnLike[index]-1
    }
    if(ValidationUtil.isNotNullAndNotEmpty(isLike) || ValidationUtil.isNotNullAndNotEmpty(isUnLike)){
      this.action = 'update';
      for (const [key, value] of this.isAction.entries()) {
        if(key == item.seq){
          this.isAction.delete(key);
          break;
        }
      }

      this.isAction.set(item.seq, [isLike, isUnLike]);
    }
    if(isLike == '' && isUnLike == '' &&  ValidationUtil.isNullOrEmpty(this.cmnt[index])){
      this._wAlertStore.dispatch(
        setWAlert({
            wAlert: {
                icon: WAlertConstant.warning,
                message: 'Please enter content to comment',
            },
        })
      );
      return;
    }

    if(!ValidationUtil.isNotNullAndNotEmpty(this.userid)){
      this.alertNotLogined();
      return;
    }else{
      let params = {
        comId:environment.comId,
        pdtCd:item.pdtCd,
        seq:item.seq,
        userid:this.userid,
        cmnt:this.cmnt[index],
        likeCmt:isLike,
        unLikeCmt:isUnLike
      }

      this._pdtDetailStore.dispatch(saveCommentPdt({params:params}));

    }

  }



  openCmntPdt(index:number){
    this.openCmnt.set(index,true)
  }

  closeCmntPdt(index:number){
    this.openCmnt.delete(index);
  }

  isOpen(index:number){
    return this.openCmnt.get(index);
  }

  loadComment(items:PdtDetailModel[]){
    this.listQtyLike= [];
    this.listQtyUnLike = [];
    for (let index = 0; index < items.length; index++) {
      this.listQtyLike.push(Number(items[index].likeCnt));
      this.listQtyUnLike.push(Number(items[index].unLikeCnt));
      this.seq.push(String(items[index].seq))

    }
    this._pdtDetailStore.dispatch(loadCommentPdt({seq:this.seq , userid:this.userid}))
  }


  alertNotLogined(): void {
    this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.confirm, message: this._translate.instant("homepage.login.msg.001") , action: this.actionConfirmLogined } }));
  }

  isLike(seq:String){
    for (const [key, value] of this.isAction.entries()) {
      if (key === seq) {
        return value[0];
      }
    }
    return 'N';
  }

  isUnLike(seq:String){
    for (const [key, value] of this.isAction.entries()) {
      if (key === seq) {
        return value[1];
      }
    }
    return 'N';
  }

  getNumber(num:any){
    return Number(num);
  }

  viewAll(){
    this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));
    this._pdtDetailStore.dispatch(getPdtReview({ pdtCd: this.pdtCdUrl ,orderBy: this.orderBy,  page: Number(this.page) - 1, len: 1000}));
  }

  handleFullImg(){
    this.fullImg = true;
  }

  handleOnClickPlus(): void {
    //this.quantity++;
    //this.total = +(this._custPrice.transform(this.pdtInfo.retailAmt, this.pdtInfo.amt)) * this.quantity;
    this.changePlus.emit('');
    
  }

  handleOnClickMinus(): void {
    //if (this.quantity === 1) return;

   // this.quantity--;
    //this.total = +(this._custPrice.transform(this.pdtInfo.retailAmt, this.pdtInfo.amt)) * this.quantity;

    this.changeMinus.emit('');
  }

  onClickWishList(event: any): void {
		this.changeWish.emit(this.wishYn);
		event.stopPropagation();
	}

  handleOnClickAddToCart(): void {
    if (this.isLogined) {
      if (Number(this.pdtInfo.amt) <= 0) {
        this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.warning, message: this._translate.instant("homepage.product.msg.005") } }));
        return;
      }
      this._cartStore.dispatch(setIsBuyNow({ isBuyNow: false }));
      this.addToCart();
    } else {
      this.alertNotLogined();
    }
  }

  handleOnClickBuyNow(): void {
    if (this.isLogined) {
      if (Number(this.pdtInfo.amt) <= 0) {
        this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.warning, message:this._translate.instant("homepage.product.msg.005")  } }));
        return;
      }
      this._cartStore.dispatch(setIsBuyNow({ isBuyNow: true }));
      this.addToCart();
    } else {
      this.alertNotLogined();
    }
  }

  addToCart(): void {
    let pdtCd = this.pdtInfo.pdtCd;
    if (ValidationUtil.isNotNullAndNotEmpty(pdtCd)) {
      let params = CartUtil.getParamsAddToCart(ConvertUtil.convertToSring(pdtCd), this.quantity);
      this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));
      this._cartStore.dispatch(addToCart({ params: params }));
    }
  }

}
